import type { V2Balance } from '../types/v2';

/** Whether the balance is a card's: production calls the type "card_balance", the code also "card". */
export const isCardBalance = (b: V2Balance): boolean =>
  b.account_type_code === 'card' || b.account_type_code === 'card_balance';

/**
 * The card Top-up opens on. From a card's own screen that card, as long as
 * the client still holds it — "Top up" there must not switch to another card,
 * and must not clear the one the screen goes back to. From anywhere else no
 * card is in hand, so the first one; none at all → null, and the Top-up tab
 * offers to apply for one.
 */
export const pickTopUpCard = (
  balances: V2Balance[],
  current?: V2Balance | null,
): V2Balance | null => {
  const cards = balances.filter(isCardBalance);
  if (current) {
    const same = cards.find((c) => c.id === current.id);
    if (same) {
      return current;
    }
  }
  return cards[0] ?? null;
};
